import { render, staticRenderFns } from "./BaseLikeButton.vue?vue&type=template&id=a56f157a&"
import script from "./BaseLikeButton.vue?vue&type=script&lang=js&"
export * from "./BaseLikeButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseLikeButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports